export const getSeasonalColor = currentMonth => {
  if (currentMonth < 2 || currentMonth === 11) return '#4972B5'; // зима;
  if (currentMonth >= 2 && currentMonth < 5) return '#789F24'; // весна
  if (currentMonth >= 5 && currentMonth < 8) return '#D9A319'; // лето
  if (currentMonth >= 8 && currentMonth < 11) return '#BF4D28'; // осень
};
